import { render, staticRenderFns } from "./MaterialProject.vue?vue&type=template&id=6fc59aa5"
import script from "./MaterialProject.vue?vue&type=script&lang=js"
export * from "./MaterialProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports